
<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row>
            <div style="position: fixed; z-index: 1;  background-color: white; width: 100%; top:55px;">
            <v-breadcrumbs :items="items" large style=" font-weight: 600; letter-spacing: 1px; ">

            </v-breadcrumbs>
            </div>
        </v-row><br><br><br />
    <v-card class="card">
      <div v-if="init_loading">
          <v-skeleton-loader v-bind="attrs" type="three-line,  article"></v-skeleton-loader>
        </div>
        <div v-else>
      <v-card-title class="heading justify-center">Departmentwise Title Summary Report</v-card-title>
      <div class="">
        <div class="add-section">
          <div class="d-flex">
            <v-col>
              <label class="add-text">Department</label>
              <v-autocomplete v-model="department" placeholder="Select Department" :items="dept_list" item-text="name"
                item-value="id" outlined dense class="text" :rules="[rules.required]" clearable required></v-autocomplete>
            </v-col>
            <v-col>
              <label class="add-text">Series</label>
              <v-autocomplete v-model="series" placeholder="Select Series" :items="series_data" item-text="name"
                item-value="id" outlined dense class="text" :rules="[rules.required]" clearable required></v-autocomplete>
            </v-col>
            <v-col>
              <label>Start Date</label>

              <v-menu v-model="fromDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y
                full-width max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field class="text" v-model="startDate" placeholder="Select Start Date" append-icon="event"
                    persistent-hint dense readonly outlined v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="startDate" no-title @input="fromDateMenu = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col>
              <label>End Date</label>

              <v-menu v-model="fromDateMenu1" :close-on-content-click="false" transition="scale-transition" offset-y
                full-width max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field class="text" v-model="endDate" placeholder="Select End Date" append-icon="event"
                    persistent-hint dense readonly outlined v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="endDate" no-title @input="fromDateMenu1 = false"></v-date-picker>
              </v-menu>
            </v-col>
          </div>
         
          <div>
            <center>
              <v-btn color="success" class="mb-4" @click="getDepartmentwiseBookReport">Fetch Data</v-btn>
            </center>
          </div>
        </div>
        </div>

        <div v-if="loader">
          <v-skeleton-loader v-bind="attrs" type="three-line,  article"></v-skeleton-loader>
        </div>
        <div v-else>
        <v-data-table :headers="headers" :search="search" :items="tabledata" class="elevation-5 ma-2" hide-default-footer
          disable-pagination>
          <template v-slot:top>
            <v-toolbar flat color="white" align="center" justify="center">
              <v-toolbar-title>Departmentwise Title Summary Report</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
              <download-excel class="ma-3" v-if="tabledata.length != 0" color="primary" dark :data="tabledata"
                :fields="table_fields" worksheet="My Worksheet" name="departmentwisetitlesummaryreport.xls">
                <v-btn color="success" dark class="mb-2">
                  <v-icon dark>mdi-file-excel</v-icon>
                </v-btn>
              </download-excel>
            </v-toolbar>
          </template>
          <template v-slot:item.date="{ item }">
            <span class="pointer" v-if="item.date != ''">
              {{ item.date.split("T")[0].split("-")[2] + "-" + item.date.split("T")[0].split("-")[1] + "-" + item.date.split("T")[0].split("-")[0] }}
            </span>
          </template>
          <template v-slot:item.title="{ item }">
            <span class="pointer" @click="gettitlecount(item)">
              {{ item.title }}
            </span>
          </template>
          <template v-slot:item.total_return_member="{ item }">
            <span class="pointer" @click="getuseroncount(item, 'student', 'return')">
              {{ item.total_return_member }}
            </span>
          </template>
          <template v-slot:item.volume="{ item }">
            <span class="pointer" @click="getvolume(item)">
              {{ item.volume }}
            </span>
          </template>
          <template v-slot:item.total_issue_emp="{ item }">
            <span class="pointer" @click="getuseroncount(item, 'employee', 'issue')">
              {{ item.total_issue_emp }}
            </span>
          </template>
          <template v-slot:item.total_return_emp="{ item }">
            <span class="pointer" @click="getuseroncount(item, 'employee', 'return')">
              {{ item.total_return_emp }}
            </span>
          </template>
          <template v-slot:item.total_emp="{ item }">
            <span class="pointer" @click="getuseroncount(item, 'employee', 'all')">
              {{ item.total_emp }}
            </span>
          </template>
          <template v-slot:item.total_issue="{ item }">
            <span class="pointer" @click="getuseroncount(item, 'all', 'issue')">
              {{ item.total_issue }}
            </span>
          </template>
          <template v-slot:item.total_return="{ item }">
            <span class="pointer" @click="getuseroncount(item, 'all', 'return')">
              {{ item.total_return }}
            </span>
          </template>
          <template v-slot:item.total_count="{ item }">
            <span class="pointer" @click="getuseroncount(item, 'all', 'all')">
              {{ item.total_count }}
            </span>
          </template>
        </v-data-table>
        </div>
      </div>
    </v-card>
    <!--dialog weedout-->
    <template>
      <v-row justify="center">

        <v-dialog v-model="dialog_bok" fullscreen hide-loadery transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dark color="gray">
              <v-btn icon dark @click="close_dialog_bok()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Books List</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text @click="close_dialog_bok()"> Close </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <br />
            <v-card-text>
              <v-card>
                <v-card-title>
                  <v-text-field v-model="search_book" append-icon="mdi-magnify" label="Search" single-line
                    hide-details></v-text-field>
                  <v-spacer></v-spacer>
                  <template>
                    <download-excel :data="titledata" :fields="header1_excel" worksheet="Departmentwise Title Data"
                      name="DepartmentwiseTitleData.xls">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="green" size="40" left v-bind="attrs" v-on="on">mdi-file-excel</v-icon>
                        </template>
                        <span>Export to Excel</span>
                      </v-tooltip>
                    </download-excel>
                  </template>
                </v-card-title>

                <v-data-table :headers="header1" :items="titledata" :search="search_book">
                </v-data-table>
              </v-card>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">

        <v-dialog v-model="dialog_book" fullscreen hide-loadery transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dark color="gray">
              <v-btn icon dark @click="close_dialog_book()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Books List</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text @click="close_dialog_book()"> Close </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <br />
            <v-card-text>
              <v-card>
                <v-card-title>
                  <v-text-field v-model="search_book" append-icon="mdi-magnify" label="Search" single-line
                    hide-details></v-text-field>
                  <v-spacer></v-spacer>
                  <template>
                    <download-excel :data="volumedata" :fields="header2_excel" worksheet="Departmentwise volume Data"
                      name="DepartmentwisevolumeData.xls">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="green" size="40" left v-bind="attrs" v-on="on">mdi-file-excel</v-icon>
                        </template>
                        <span>Export to Excel</span>
                      </v-tooltip>
                    </download-excel>
                  </template>
                </v-card-title>

                <v-data-table :headers="header2" :items="volumedata" :search="search_book">
                </v-data-table>
              </v-card>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!--end dialog weedout-->
    
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    loadery: false,
    series: null,
    search_book: "",
    fromDateMenu1: false,
    usertype: null,
    titledata: [],
    volumedata: [],
    valid: false,
    loadery: false,
    userid: "",
    bookitemid: "",
    init_loading: false,
    selected: [],
    errorMsg: {
      roleLinkId: false,
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    tabledata: [],
    snackbar: false,
    loader: false,
    items: [
      {
        text: 'Dashboard',
        disabled: false,
        href: '/home',
      },
      {
        text: localStorage.getItem("jhhjbyj"),
        disabled: false,
        href: '/sublink',
      },
      {
        text: 'Reports',
        disabled: false,
        href: '/reports',
      },
      {
        text: 'Departmentwise Title Summary Report',
        disabled: true,
        href: '',
      },
    ],
    snackbar_msg: "",
    color: "",
    search: "",
    org: "",
    dialog_book: false,
    dialog_bok: false,
    dialog: false,
    fromDateMenu: false,
    fromDateVal: [],
    dept_list: [],
    department: null,
    startDate: "",
    endDate: "",
    dailyData: [],
    series_data: [],
    usertype_data: [],
    minDate: "1990-01-01",
    maxDate: new Date(),
    series: "",
    no_of_days: 90,
    title_wise: true,
    dept_name: "",
    user_type: "",


    headers: [
      {
        text: "Sr no",
        align: "left",
        sortable: true,
        value: "srno",
      },

      {
        text: "Title",
        align: "left",
        sortable: true,
        value: "title",
      },


      {
        text: "Department",
        align: "left",
        sortable: true,
        value: "department",
      },
      {
        text: "Volume",
        align: "left",
        sortable: true,
        value: "volume",
      },
      {
        text: "Price",
        align: "left",
        sortable: true,
        value: "total",
      },


    ],
    header1: [
      {
        text: "Sr no",
        align: "left",
        value: "srno",
      },
      {
        text: "ISBN_No",
        align: "left",
        value: "isbn",
      },

      {
        text: "Title",
        align: "left",
        value: "title",
      },
      {
        text: "Author",
        align: "left",
        value: "author",
      },
      {
        text: "Price",
        align: "left",
        value: "price",
      },

    ],

    header2: [
      {
        text: "Sr no",
        align: "left",
        value: "srno",
      },

      {
        text: "Accession_number",
        align: "left",
        value: "accno",
      },
      {
        text: "Title",
        align: "left",
        value: "title",
      },

      {
        text: "Author",
        align: "left",
        value: "author",
      },
      {
        text: "Price",
        align: "left",
        value: "price",
      },

    ],
    table_fields:
    {
      "Sr no": "srno",

      "Title": "title",
      "Department": "department",
      "Volume": "volume",
      " Total Price": "total",

    },
    header1_excel: {
      "Sr no": "srno",
      "ISBN_No": "isbn",
      "Title": "title",
      "Author": "author",
      "Price": "price",

    },
    header2_excel: {
      "Sr no": "srno",
      "Accession_number	": "accno",
      "Title": "title",
      "Author": "author",
      "Price": "price",

    },


  }),
  computed: {
    fromDateDisp() {
      return this.fromDateVal;
      // format/do something with date
    },
    filteredDesserts() {
      return this.dailyData.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
  },

  mounted() {
    this.startDate = moment(String('1900-01-01')).format("YYYY-MM-DD");

    this.endDate = moment(String(new Date())).format("YYYY-MM-DD");
    this.onLoad();
  },
  methods: {
    getDepartmentwiseBookReport() {
      this.loader = true;

      const data = {
        firstDate: moment(String(this.startDate)).format("DD-MM-YYYY"),
        lastDate: moment(String(this.endDate)).format("DD-MM-YYYY"),
        series_id: this.series,
        department: this.department,

        colData: this.colData,
      };
      axios
        .post("/Report/getDepartmentwiseBookReport", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.loader = false;
            this.tabledata = res.data.list;
            if (this.tabledata.length == 0) {
              this.showSnackbar("#b71c1c", "No data available ");
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
          this.loader = false;
        })
        .finally(() => { });
    },
    close_dialog_book() {
      this.dialog_book = false;

    },
    close_dialog_bok() {
      this.dialog_bok = false;

    },
    gettitlecount(item) {


      this.loadery = true;
      const data = {

        firstDate: moment(String(this.startDate)).format("DD-MM-YYYY"),
        lastDate: moment(String(this.endDate)).format("DD-MM-YYYY"),
        series_id: this.series,
        department: item.department,



      };
      axios
        .post("/Report/departmentwisetitle", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.loadery = false;
            this.dialog_bok = true;
            this.titledata = res.data.list;

            console.log(this.titledata)

          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
          this.loadery = false;
        })
        .finally(() => { });
    },

    getvolume(item) {

      this.loadery = true;
      const data = {

        firstDate: moment(String(this.startDate)).format("DD-MM-YYYY"),
        lastDate: moment(String(this.endDate)).format("DD-MM-YYYY"),
        series_id: this.series,
        department: item.department,



      };
      axios
        .post("/Report/departmentwisevolume", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.loadery = false;
            this.dialog_book = true;
            this.volumedata = res.data.list;

            console.log(this.volumedata)

          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
          this.loadery = false;
        })
        .finally(() => { });
    },
    exportexcel() {
      $("#exceltable").table2excel({
        name: "Worksheet Name",
        filename: "Over_Due_Report", //do not include extension
        fileext: ".xls" // file extension
      });
    },
    onLoad() {
      this.init_loading = true;
      axios
        .post("/Librarian/getseriesData")
        .then((res) => {
          if (res.data.msg == "200") {
            this.init_loading = false;
            this.series_data = res.data.series_data;
            this.series_data.push({ name: "ALL", id: "ALL" });
            this.series = "ALL";
            this.usertype_data = res.data.usertype_data;
            this.dept_list = res.data.dept_list
            this.dept_list.push({ name: "ALL", id: "ALL" });
            this.department = "ALL";
            this.no_of_days = res.data.no_of_days;
            const today = new Date();
            const previousdate = new Date();
            previousdate.setDate(today.getDate() - 9000);
          }
        })

        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);

        })
        .finally(() => {
          // var loadery = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    close() {
      this.dialog = false;
      // this.$refs.form.reset()
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.fields {
  padding: 0px !important;
}

.cus-card {
  background: #d3d3d33d;
  margin: 1rem;
  padding: 1rem;
  border: 2px solid gray;
}

.c-label {
  font-weight: bold;
}

.add-section {
  display: block;
  margin: 1rem;
}

.text>>>.v-input__slot {
  background: white !important;
  border-color: hsla(190, 99%, 30%, 1) !important;
}

.elevation-1 /deep/ tr {
  white-space: nowrap !important;
}

.d-btn {
  display: flex;
  justify-content: flex-end;
  margin: 0.5rem;
}

.checkbox {
  margin: 1rem;
  border: 1px solid;
  background: #d3d3d380;
}

.checkbox .box {
  margin-top: 5px;
}

.pointer {
  cursor: pointer;
}

.checkbox /deep/ .v-input--selection-controls {
  margin-top: 0px !important;
}
</style>
